import { Grid, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { DrawerWidget, ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import SelectFieldTorneosComponent from '../torneos/components/SelectFieldTorneos';
import { allJuegosAction, setActivoJuegosAction } from './JuegosAction';
import { PARAMS_JUEGOS } from './JuegosReducer';
import FormJuegos from './components/FormJuegos';
import ListadoJuegos from './components/ListadoJuegos';

const JuegosView = () => {
  const dispatch = Redux.useDispatch();

  const juegosStore = Redux.useSelector((state) => state.juegos);
  const torneosStore = Redux.useSelector((state) => state.torneos);

  const [openModalForm, setOpenModalForm] = React.useState(false);
  const [isFiltros, setIsFiltros] = React.useState(false);

  React.useEffect(() => {
    setIsFiltros(!juegosStore.params.idTorneo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid
        item
        md={12}
        sx={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <div>
          <BotonComponent
            click={async () => {
              await setActivoJuegosAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            addIcon
            mr={2}
            ml={2}
            mt={2}
            mb={1}
          />
          <BotonComponent
            click={async () => {
              await setActivoJuegosAction(dispatch, null);
              await allJuegosAction(dispatch, juegosStore.params);
            }}
            disabled={juegosStore.all.length === 0 || juegosStore.loadingAll}
            mt={2}
            mb={1}
            white
            refreshIcon
            text={juegosStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
          />
        </div>
        {!torneosStore.activo && (
          <Stack direction="row" justifyContent="flex-end">
            <BotonComponent
              text={`FILTROS ${isFiltros ? 'ACTIVO' : ''}`}
              filterIcon
              click={() => setIsFiltros(!isFiltros)}
              white={!isFiltros}
              blue={isFiltros}
              mb={1}
              mt={2}
            />
          </Stack>
        )}
      </Grid>
      <Grid item md={12}>
        <ListadoJuegos setOpenModalForm={(val) => setOpenModalForm(val)} />
      </Grid>
      <DrawerWidget open={isFiltros} onClose={(val) => setIsFiltros(val)}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12} sx={{ mb: 2 }}>
            <Typography variant="h6" color="initial">
              FILTROS
            </Typography>
          </Grid>
          <Grid item md={12}>
            <SelectFieldTorneosComponent
              isAll={false}
              value={juegosStore.params.idTorneo}
              onChange={async (idTorneo) => {
                const payload = {
                  ...juegosStore.params,
                  idTorneo,
                };
                dispatch({ type: PARAMS_JUEGOS, payload });
                await allJuegosAction(dispatch, payload);
              }}
            />
          </Grid>
        </Grid>
      </DrawerWidget>
      <ModalComponent
        id="modalFormJuegos"
        title={`${
          juegosStore.activo
            ? `Editar ${juegosStore.activo.nombre}`
            : 'Nuevo juego'
        }`}
        maxWidth="sm"
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormJuegos
          activo={juegosStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default JuegosView;
